import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MotivoBajaAdheridoControllerService, MotivoBajaAdheridoDTO } from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';

export const TIPO_BAJA = 'BAJA';
export const TIPO_BAJA_ENVALORA = 'BAJA_ENVALORA';

@Component({
  selector: 'lib-attached-baja-motivo-dialog',
  templateUrl: './attached-baja-motivo-dialog.component.html',
  styleUrls: ['./attached-baja-motivo-dialog.component.scss'],
})
export class AttachedBajaMotivoDialogComponent implements OnInit {
  motivosBaja: MotivoBajaAdheridoDTO[] = [];
  adheridos: any[] = [];
  tipoBaja: string = TIPO_BAJA;

  añoHoy = new Date().getFullYear();
  arrayAnios: any = [this.añoHoy - 1, this.añoHoy, this.añoHoy + 1, this.añoHoy + 2];

  formGroup!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AttachedBajaMotivoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private motivoBajaAdheridoControllerService: MotivoBajaAdheridoControllerService,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService
  ) {
    this.adheridos = this.data?.adheridos ?? [];
    this.tipoBaja = this.data?.tipoBaja ?? TIPO_BAJA;

    this.formGroup = this.formBuilder.group({
      motivoBaja: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      anioUltimoDatos: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fechaFinContrato: [
        { value: null, disabled: false },
        this.esBajaEnvalora()
          ? { validators: Validators.compose([Validators.required]) }
          : {},
      ],
      observacionesBaja: [{ value: null, disabled: false }],
    });
  }

  ngOnInit(): void {
    this.cargarMotivosBaja();
  }

  esBajaEnvalora(): boolean {
    return this.tipoBaja === TIPO_BAJA_ENVALORA;
  }

  cargarMotivosBaja(): void {
    this.motivoBajaAdheridoControllerService.findAll4().subscribe({
      next: (data: MotivoBajaAdheridoDTO[]) => {
        this.motivosBaja = data!;
      },
      error: () => {},
    });
  }

  guardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      const motivoBajaId = this.formGroup.get('motivoBaja')?.value;
      const anioUltimosDatos = this.formGroup.get('anioUltimoDatos')?.value;
      const fechaFinContrato = this.formGroup.get('fechaFinContrato')?.value;
      const observacionesBaja = this.formGroup
        .get('observacionesBaja')
        ?.value?.trim();

      const datosBaja: any = {
        motivoBajaId: motivoBajaId,
        anioUltimosDatos: anioUltimosDatos,
        observacionesBaja: observacionesBaja,
      };
      if (this.esBajaEnvalora()) {
        datosBaja.fechaFinContrato = fechaFinContrato;
      }

      this.dialogRef.close(datosBaja);
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }
}
